import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import { formatDateDb, formatDateHourDb } from "../utils/tools";
import {
  customDateFormatType,
  formatDateForInput,
  formatNumber,
} from "../utils/utils";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.lockingManagement;
const queryKey = "locking";

const formatTotalCommissionStatus = (stepCommission) => {
  const totatCalculateCommission = stepCommission.reduce((total, item) => {
    return total + (item?.calculateCommissionRate || 0);
  }, 0);

  if (totatCalculateCommission === 0) {
    return "Chưa đối chiếu";
  } else if (totatCalculateCommission > 0 && totatCalculateCommission < 100) {
    return "Đang đối chiếu";
  } else if (totatCalculateCommission >= 100) {
    return "Đã đối chiếu";
  }
};

async function fetchServiceFeeManagement(
  currentPage,
  search,
  projectId,
  bookerId,
  lockingEventId,
  status,
  isTtkqHdmbs,
  apartmentId,
  customerId,
  startTime,
  endTime,
  saleBlockId,
  saleAreaId,
  startTimeCreated,
  endTimeCreated,
  startCalculate,
  inputLate,
  approveTransaction,
  saleOpeningEventId,
  minPriceOfCommission,
  maxPriceOfCommission,
  saleEmployeeId,
  startTimeTtkq,
  endTimeTtkq,
  startTimeHdmb,
  endTimeHdmb,
  reconciliationMonthDate,
) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search !== undefined) options.search = search;
    if (projectId?.length) options.projectId = projectId;
    if (bookerId) options.bookerId = bookerId;
    if (lockingEventId) options.lockingEventId = lockingEventId;
    if (status?.length) options.status = status;
    if (isTtkqHdmbs) options.isTtkqHdmbs = isTtkqHdmbs;
    if (apartmentId?.length) options.apartmentId = apartmentId;
    if (customerId) options.customerId = customerId;
    if (startTime) options.startTime = customDateFormatType(startTime);
    if (endTime) options.endTime = customDateFormatType(endTime);
    if (saleBlockId) options.saleBlockId = saleBlockId;
    if (saleAreaId) options.saleAreaId = saleAreaId;
    if (startCalculate) options.startCalculate = startCalculate;
    if (approveTransaction) options.approveTransaction = approveTransaction;
    if (startTimeCreated)
      options.startTimeCreated = customDateFormatType(startTimeCreated);
    if (endTimeCreated)
      options.endTimeCreated = customDateFormatType(endTimeCreated);
    if (inputLate) options.inputLate = inputLate;
    if (saleOpeningEventId) options.saleOpeningEventId = saleOpeningEventId;
    if (minPriceOfCommission) options.minPriceOfCommission = minPriceOfCommission;
    if (maxPriceOfCommission) options.maxPriceOfCommission = maxPriceOfCommission;
    if (saleEmployeeId) options.saleEmployeeId = saleEmployeeId;
    if (startTimeTtkq) options.startTimeTtkq = customDateFormatType(startTimeTtkq);
    if (endTimeTtkq) options.endTimeTtkq = customDateFormatType(endTimeTtkq);
    if (startTimeHdmb) options.startTimeHdmb = customDateFormatType(startTimeHdmb);
    if (endTimeHdmb) options.endTimeHdmb = customDateFormatType(endTimeHdmb);
    if (reconciliationMonthDate) {
      const d = new Date(reconciliationMonthDate);
      options.reconciliationMonth = d.getMonth() + 1;
      options.reconciliationYear = d.getFullYear();
    }
    // options.isAgent = 2;

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/locking?${queryParams}`);
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries,
    );

    const newData = data?.items.map((item, index) => {
      return {
        id: item?._id || "",
                stepCommission: item?.stepCommission || [],
        // status: item?.status || "",
        calculateServiceFees: item?._id || "",
        inputLate: item?.inputLate || false,
        totalCommissionStatus: formatTotalCommissionStatus(
          item?.stepCommission || [],
        ),
        codeApartment: item?.apartmentObject?.code || "-",
        nameProject: item?.projectObject?.name || "-",
        nameSaleOpeningEvent: item?.saleOpeningEvent?.name || "-",
        nameCustomer: item?.customerObject?.name || "-",
        estimatePriceOfCommission: item?.apartment?.estimatedServiceFeePrice
          ? `${formatNumber(Number(item?.apartment?.estimatedServiceFeePrice))} VNĐ`
          : "0 VNĐ",
        priceOfCommission: item?.apartment?.priceForCommission
          ? `${formatNumber(Number(item?.apartment?.priceForCommission))} VNĐ`
          : "0 VNĐ",
        nameLocking: item?.bookerObject?.fullName || "-",
        participantList: item?.lockingParticipant?.length
          ? item?.lockingParticipant
          : [],
        saleBlock: item?.saleBlock?.name || "-",
        saleArea: item?.saleArea?.name || "-",
        bookingTime: item?.bookingTime ? formatDateDb(item?.bookingTime) : "-",
        createdAt: item?.createdAt ? formatDateDb(item?.createdAt) : "-",
        signingDateTTKQ: item?.ttkq?.priceTime
          ? formatDateDb(item?.ttkq?.priceTime)
          : "-",
        signingDateHDBM: item?.salesContract?.priceTime
          ? formatDateDb(item?.salesContract?.priceTime)
          : "-",
        // saleOpeningEvent: item?.saleOpeningEvent?.code || "-",
        // booking: item?.booking?.code || "-",
        // nameApartment: item?.apartmentObject?.name || "-",
        // price: item?.price
        //   ? `${formatNumber(Number(item?.price))} VNĐ`
        //   : "0 VNĐ",
        // agentName: item?.agent?.name || "-",
        // note: item?.note || "-",
        statusTtkq: item?.statusTtkq ? true : false,
        statusSalesContract: item?.statusSalesContract ? true : false,
        is_allow_ttkq: item?.project?.is_allow_ttkq || false,
        registerRelativeStatus:
          item?.registerRelativeStatus === "APPROVED" ? false : true,
        edit: {
          id: item?._id || "",
          note: item?.note || "",
          nameBooker: item?.nameBooker || "",
          projectId: item?.projectId || "",
          saleOpeningEventId: item?.saleOpeningEventId || "",
          bookingId: item?.bookingId || "",
          customerId: item?.customerId || "",
          price: item?.price || "",
          bookingTime: item?.bookingTime
            ? formatDateForInput(item?.bookingTime)
            : "",
          apartmentId: item?.apartmentId || "",
          paymentMethodId: item?.paymentMethodId || "",
          bookerId: item?.bookerId || "",
          createdAt: item?.createdAt ? formatDateDb(item?.createdAt) : "-",
          images: item?.images,
        },
        detail: {
          id: item?._id || "",
          status: item?.status || "",
          saleOpeningEvent: item?.saleOpeningEvent?.code || "",
          booking: item?.booking?.code || "",
          note: item?.note || "",
          nameBooker: item?.bookerObject?.fullName || "",
          createdAt: item?.createdAt ? formatDateDb(item?.createdAt) : "-",
          project: item?.project?.name || "",
          customer: item?.customerObject?.name || "",
          price: item?.price
            ? `${formatNumber(Number(item?.price))} VNĐ`
            : "0 VNĐ",
          bookingTime: item?.bookingTime ? formatDateDb(item?.bookingTime) : "",
          apartment: item?.apartmentObject?.name || "",
          codeApartment: item?.apartmentObject?.code || "",
          apartments: item?.apartment,
          paymentMethod: item?.paymentMethod?.name || "",
          images: item?.images,
          agentName: item?.agent?.name || "-",
          saleBlock: item?.saleBlock?.name || "-",
          saleArea: item?.saleArea?.name || "-",
          statusSalesContract: item?.statusSalesContract || false,
        },
      };
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useServiceFeeManagement(
  search,
  projectId,
  bookerId,
  lockingEventId,
  status,
  isTtkqHdmbs,
  apartmentId,
  customerId,
  startTime,
  endTime,
  saleBlockId,
  saleAreaId,
  startDateCreated,
  endDateCreated,
  startCalculate,
  inputLate,
  approveTransaction,
  saleOpeningEventId,
  minPriceOfCommission,
  maxPriceOfCommission,
  saleEmployeeId,
  startTimeTtkq,
  endTimeTtkq,
  startTimeHdmb,
  endTimeHdmb,
  reconciliationMonthDate,
) {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [
      queryKey,
      currentPage,
      search,
      projectId,
      bookerId,
      lockingEventId,
      status,
      isTtkqHdmbs,
      apartmentId,
      customerId,
      startTime,
      endTime,
      saleBlockId,
      saleAreaId,
      startDateCreated,
      endDateCreated,
      startCalculate,
      inputLate,
      approveTransaction,
      saleOpeningEventId,
      minPriceOfCommission,
      maxPriceOfCommission,
      saleEmployeeId,
      startTimeTtkq,
      endTimeTtkq,
      startTimeHdmb,
      endTimeHdmb,
      reconciliationMonthDate,
    ],
    queryFn: () =>
      fetchServiceFeeManagement(
        currentPage,
        search,
        projectId,
        bookerId,
        lockingEventId,
        status,
        isTtkqHdmbs,
        apartmentId,
        customerId,
        startTime,
        endTime,
        saleBlockId,
        saleAreaId,
        startDateCreated,
        endDateCreated,
        startCalculate,
        inputLate,
        approveTransaction,
        saleOpeningEventId,
        minPriceOfCommission,
        maxPriceOfCommission,
        saleEmployeeId,
        startTimeTtkq,
        endTimeTtkq,
        startTimeHdmb,
        endTimeHdmb,
        reconciliationMonthDate,
      ),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    placeholderData: keepPreviousData,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    lockingManagementData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
